import { Grid } from '@mui/material'
import styles from './EFManagerCover.module.scss'
import classNames from 'classnames/bind'
import { logoDarkSmall } from '~/assets/images'
import { Link } from 'react-router-dom'
import { PATH_NAME } from '~/constants/paths'

const cx = classNames.bind(styles)

export function EFManagerCover() {
  return (
    <Grid className={cx('ef-cover')}>
      <div className={cx('half-circle-1')}></div>
      <div className={cx('half-circle-2')}></div>
      <div className={cx('half-circle-3')}></div>
      <div className={cx('half-circle-4')}></div>
      <Link to={PATH_NAME.LOGIN_PAGE.path}>
        <img
          src={logoDarkSmall}
          alt='logo'
          className={cx('logo-large')}
        />
      </Link>
      <div className={cx('text-contain')}>
        <h1>Welcome to</h1>
        <div>TAIT EnableFleet Manager</div>
        <p>
          Tait EnableFleet Manager provides a window into the Tait EnableFleet
          configuration management system database.
        </p>
      </div>
    </Grid>
  )
}
